<template>
  <div class="icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="ionicon"
      viewBox="0 0 512 512"
    >
      <title>Options</title>
      <path
        fill="#333"
        stroke="#333"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
        d="M368 128h80M64 128h240M368 384h80M64 384h240M208 256h240M64 256h80"
      />
      <circle
        cx="336"
        cy="128"
        r="32"
        fill="#333"
        stroke="#333"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
      />
      <circle
        cx="176"
        cy="256"
        r="32"
        fill="#333"
        stroke="#333"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
      />
      <circle
        cx="336"
        cy="384"
        r="32"
        fill="#333"
        stroke="#333"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "Company",
};
</script>

<style scoped lang="scss">
.icon {
  width: 20px;
  &:active {
    opacity: 0.2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/icons/Options.vue